<div class="page-content" page-content>
  <prism-ui-heading
    font-size="lg"
    font-weight="regular"
    key-id="med-history-title"
    is-uppercase="false"
    variant="default"
    >{{pageTitle}}
  </prism-ui-heading>
  <form [formGroup]="medHistoryForm" (ngSubmit)="onSubmit()" autocomplete="off">

    <prism-ui-container
      is-compact="false"
      key-id="med-history-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >

      <div class="form-group">
        <div class="">
          @if (!noHeightAndWeight) {
            <div>
              <div class="row">
                <prism-ui-copy>
                  <p>Please enter the applicant’s information below.</p>
                </prism-ui-copy>
                <br>
                </div>
                <div class="row">
                  <prism-ui-copy>
                    <p class="">What is the applicant’s height and weight?</p>
                  </prism-ui-copy>
                </div>
                <div class="heightWeightContainer">
                  <div class="containerTwo">
                    <div class="item oneCell" id="mq-10001-height-feet">
                      <prism-ui-form-field
                        key-id="mq-10001-height-feet"
                        [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-height-feet')"
                        >
                        <span slot="label">Feet</span>
                        @if (medHistoryForm.get('mq-10001-height-feet').hasError('required')
                          && medHistoryForm.get('mq-10001-height-feet').touched) {
                          <span slot="error">{{ requiredElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-feet').hasError('maxLength')
                          && medHistoryForm.get('mq-10001-height-feet').touched) {
                          <span slot="error">{{ feetElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-feet').hasError('min')
                          && medHistoryForm.get('mq-10001-height-feet').touched) {
                          <span slot="error">{{ feetNumElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-feet').hasError('pattern')
                          && medHistoryForm.get('mq-10001-height-feet').touched) {
                          <span slot="error">{{ feetNumElement?.error }}</span>
                        }
                        <prism-ui-input-text
                          autocomplete="new-password"
                          slot="input"
                          is-required="true"
                          [maxLength]="maxLengthFeet"
                          ngDefaultControl
                          [name]="heightFeetFieldName"
                          formControlName="mq-10001-height-feet"
                          [formGroup]="medHistoryForm"
                          key-id="mq-10001-height-feet"
                          placeholder="Feet"
                          [defaultValue]="medHistoryForm.get('mq-10001-height-feet')?.value"
                          [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-height-feet')"
                          (focusout)="heightLeaveEvent($event)"
                        ></prism-ui-input-text>
                      </prism-ui-form-field>
                    </div>
                    <div class="item oneCell" id="mq-10001-height-inches">
                      <prism-ui-form-field
                        key-id="mq-10001-height-inches"
                        [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-height-inches')"
                        >
                        <span slot="label">Inches</span>
                        @if (medHistoryForm.get('mq-10001-height-inches').hasError('required')
                          && medHistoryForm.get('mq-10001-height-inches').touched) {
                          <span slot="error">{{ requiredElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-inches').hasError('max')
                          && medHistoryForm.get('mq-10001-height-inches').touched) {
                          <span slot="error">{{ inchesNumElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-inches').hasError('min')
                          && medHistoryForm.get('mq-10001-height-inches').touched) {
                          <span slot="error">{{ inchesNumElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-inches').hasError('maxLength')
                          && medHistoryForm.get('mq-10001-height-inches').touched) {
                          <span slot="error">{{ inchesElement?.error }}</span>
                        }
                        @if (medHistoryForm.get('mq-10001-height-inches').hasError('pattern')
                          && medHistoryForm.get('mq-10001-height-inches').touched) {
                          <span slot="error">{{ inchesNumElement?.error }}</span>
                        }
                        <prism-ui-input-text
                          autocomplete="new-password"
                          slot="input"
                          is-required="true"
                          [maxLength]="maxLengthInches"
                          ngDefaultControl
                          [name]="heightInchesFieldName"
                          formControlName="mq-10001-height-inches"
                          [formGroup]="medHistoryForm"
                          key-id="mq-10001-height-inches"
                          placeholder="Inches"
                          [defaultValue]="medHistoryForm.get('mq-10001-height-inches')?.value"
                          [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-height-inches')"
                          (focusout)="inchesLeaveEvent($event)"
                        ></prism-ui-input-text>
                      </prism-ui-form-field>
                    </div>
                  </div>
                  <div class="item oneCell" id="mq-10001-weight">
                    <prism-ui-form-field
                      key-id="mq-10001-weight"
                      [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-weight')"
                      >
                      <span slot="label">Weight (lbs)</span>
                      @if (medHistoryForm.get('mq-10001-weight').hasError('required')
                        && medHistoryForm.get('mq-10001-weight').touched) {
                        <span slot="error">{{ requiredElement?.error }}</span>
                      }
                      @if (medHistoryForm.get('mq-10001-weight').hasError('max')
                        && medHistoryForm.get('mq-10001-weight').touched) {
                        <span slot="error">{{ weightNumElement?.error }}</span>
                      }
                      @if (medHistoryForm.get('mq-10001-weight').hasError('min')
                        && medHistoryForm.get('mq-10001-weight').touched) {
                        <span slot="error">{{ weightNumElement?.error }}</span>
                      }
                      @if (medHistoryForm.get('mq-10001-weight').hasError('maxLength')
                        && medHistoryForm.get('mq-10001-weight').touched) {
                        <span slot="error">{{ weightElement?.error }}</span>
                      }
                      @if (medHistoryForm.get('mq-10001-weight').hasError('pattern')
                        && medHistoryForm.get('mq-10001-weight').touched) {
                        <span slot="error">{{ weightNumElement?.error }}</span>
                      }
                      <prism-ui-input-text
                        autocomplete="new-password"
                        slot="input"
                        is-required="true"
                        [maxLength]="maxLengthWeight"
                        ngDefaultControl
                        [name]="weightFieldName"
                        formControlName="mq-10001-weight"
                        [formGroup]="medHistoryForm"
                        key-id="mq-10001-weight"
                        placeholder="Weight (lbs)"
                        [defaultValue]="medHistoryForm.get('mq-10001-weight')?.value"
                        [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, 'mq-10001-weight')"
                        (focusout)="weightLeaveEvent($event)"
                      ></prism-ui-input-text>
                    </prism-ui-form-field>
                  </div>
                </div>
              </div>
            }

            <br>
              @if (isGenericDynamicForm) {
                <div class="row section-body">
                  <prism-ui-copy key-id="mhs-note" copyText="{{mhsQuestions.note}}">
                    @if (mhsQuestions.note) {
                      <h2 class="med-history-note" [innerHTML]="mhsQuestions.note"></h2>
                    }
                  </prism-ui-copy>
                  <prism-ui-copy key-id="mhs-header" copyText="{{mhsQuestions.header}}">
                    <p  [innerHTML]="mhsQuestions.header"></p>
                  </prism-ui-copy>
                </div>
                <div class="row">
                  <ul style="list-style-type:disc;">
                    @for (con of controls; track con) {
                      @if (con.use === 'ui' && checkApplicantType(applicantType, con.applicantType )) {
                        <div [id]="con.key">
                          <prism-ui-copy key-id="control-label-{{con.key}}" copyText="{{con.label}}">
                            <li [innerHTML]="con.label"></li>
                          </prism-ui-copy>
                        </div>
                        @if (con.controlType === 'yesno') {
                          <prism-ui-form-field-select
                            [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, con.key)"
                            hide-legend="true"
                            >
                            <span slot="error">This field is required.</span>
                          </prism-ui-form-field-select>
                          <div class="dualRadioHorizontalMhs">
                            @for (opt of yesNoRadioButtonOptions; track opt; let index = $index) {
                              <div id="{{con.key}}-{{ index }}" formArrayName="{{con.key}}" slot="input-{{ index + 1 }}">
                                <prism-ui-radio-button
                                  labelText="{{opt.label}}"
                                  [keyId]="con.key + opt.name"
                                  ngDefaultControl
                                  [name]="con.key + opt.name"
                                  formControlName="{{ con.key + index }}"
                                  [checked]="medHistoryForm.get(con.key).value === opt.name"
                                  [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, con.key)"
                                  (prismUiRadioButtonOnChange)="logYesNoRadioChangeEvent(con.key, opt.name)"
                                  >
                                </prism-ui-radio-button>
                              </div>
                            }
                          </div>
                          @if (medHistoryForm.get(con.key).value === 'yes') {
                            <app-additional-details [mhsControl]="con" [parentForm]="medHistoryForm"></app-additional-details>
                            @if (con.levelTwoQuestions.length > 0 && checkApplicantType(applicantType, con.applicantType )) {
                              <app-mhs-checkbox [parentKey]="con.key" [parentForm]="medHistoryForm" [controlType]="con.controlType"
                              [levelTwoQuestions]="con.levelTwoQuestions" [listType]="con.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                            }
                          }
                        }
                      }
                      @if (con.additionalQuestions.length > 0 && checkApplicantType(applicantType, con.applicantType )) {
                        <ul style="list-style-type:disc;">
                          @for (sub of con.additionalQuestions; track sub) {
                            @if (checkApplicantType(applicantType, sub.applicantType )) {
                              <div [id]="sub.key">
                                <prism-ui-copy>
                                  <li [innerHTML]="sub.label"></li>
                                </prism-ui-copy>
                              </div>
                              @if (sub.controlType === 'yesno') {
                                <prism-ui-form-field-select
                                  [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, sub.key)"
                                  hide-legend="true"
                                  >
                                  <span slot="error">This field is required.</span>
                                </prism-ui-form-field-select>
                                <div fxLayout="row wrap" class="dualRadioHorizontalMhs">
                                  @for (opt of yesNoRadioButtonOptions; track opt; let index = $index) {
                                    <div id="{{sub.key}}" formArrayName="{{sub.key}}" slot="input-{{ index + 1 }}">
                                      <prism-ui-radio-button
                                        labelText="{{opt.label}}"
                                        [keyId]="sub.key + opt.name"
                                        ngDefaultControl
                                        [name]="sub.key + opt.name"
                                        formControlName="{{ sub.key + index }}"
                                        [checked]="medHistoryForm.get(sub.key).value === opt.name"
                                        [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, sub.key)"
                                        (prismUiRadioButtonOnChange)="logYesNoRadioChangeEvent(sub.key, opt.name)"
                                        >
                                      </prism-ui-radio-button>
                                    </div>
                                  }
                                </div>
                                @if (medHistoryForm.get(sub.key).value === 'yes') {
                                  <app-additional-details [mhsControl]="sub" [parentForm]="medHistoryForm"></app-additional-details>
                                  @if (sub.levelTwoQuestions && sub.levelTwoQuestions.length > 0) {
                                    <app-mhs-checkbox [parentKey]="sub.key" [id]="sub.key + '-checkbox-group'"
                                    [parentForm]="medHistoryForm" [levelTwoQuestions]="sub.levelTwoQuestions" [listType]="sub.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                                  }
                                }
                              }
                              @if (sub.controlType === 'checkboxes') {
                                <app-mhs-checkbox [parentKey]="sub.key" [parentForm]="medHistoryForm" [controlType]="sub.controlType"
                                [levelTwoQuestions]="sub.levelTwoQuestions" [listType]="sub.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                              }
                            }
                          }
                        </ul>
                      }
                    }
                  </ul>
                </div>
              }
              @if (!isGenericDynamicForm) {
                <div class="row section-body">
                  <prism-ui-copy>
                    @if (mhsQuestions.note) {
                      <h2 class="med-history-note" [innerHTML]="mhsQuestions.note"></h2>
                    }
                  </prism-ui-copy>
                  <prism-ui-copy>
                    <p  [innerHTML]="mhsQuestions.header"></p>
                  </prism-ui-copy>
                </div>
                <div class="row">
                  <ol type="1">
                    @for (con of controls; track con) {
                      <div [id]="con.key">
                        <prism-ui-copy>
                          <li [innerHTML]="con.label"></li>
                        </prism-ui-copy>
                      </div>
                      @if (con.controlType === 'yesno') {
                        <prism-ui-form-field-select
                          [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, con.key)"
                          hide-legend="true"
                          >
                          <span slot="error">This field is required.</span>
                        </prism-ui-form-field-select>
                        <div class="dualRadioHorizontalMhs">
                          @for (opt of yesNoRadioButtonOptions; track opt; let index = $index) {
                            <div id="{{con.key}}-{{ index }}" formArrayName="{{con.key}}" slot="input-{{ index + 1 }}">
                              <prism-ui-radio-button
                                labelText="{{opt.label}}"
                                [keyId]="con.key + opt.name"
                                ngDefaultControl
                                [name]="con.key + opt.name"
                                formControlName="{{ con.key + index }}"
                                [checked]="medHistoryForm.get(con.key).value === opt.name"
                                [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, con.key)"
                                (prismUiRadioButtonOnChange)="logYesNoRadioChangeEvent(con.key, opt.name)"
                                >
                              </prism-ui-radio-button>
                            </div>
                          }
                        </div>
                        @if (medHistoryForm.get(con.key).value === 'yes') {
                          <app-additional-details [mhsControl]="con" [parentForm]="medHistoryForm"></app-additional-details>
                          @if (con.levelTwoQuestions.length > 0) {
                            <app-mhs-checkbox [parentKey]="con.key" [parentForm]="medHistoryForm" [controlType]="con.controlType"
                            [levelTwoQuestions]="con.levelTwoQuestions" [listType]="con.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                          }
                        }
                      }
                      @if (con.additionalQuestions.length > 0) {
                        <ol type="A">
                          @for (sub of con.additionalQuestions; track sub) {
                            <div [id]="sub.key">
                              <prism-ui-copy>
                                <li [innerHTML]="sub.label"></li>
                              </prism-ui-copy>
                            </div>
                            @if (sub.controlType === 'yesno') {
                              <prism-ui-form-field-select
                                [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, sub.key)"
                                hide-legend="true"
                                >
                                <span slot="error">This field is required.</span>
                              </prism-ui-form-field-select>
                              <div fxLayout="row wrap" class="dualRadioHorizontalMhs">
                                @for (opt of yesNoRadioButtonOptions; track opt; let index = $index) {
                                  <div id="{{sub.key}}" formArrayName="{{sub.key}}" slot="input-{{ index + 1 }}">
                                    <prism-ui-radio-button
                                      labelText="{{opt.label}}"
                                      [keyId]="sub.key + opt.name"
                                      ngDefaultControl
                                      [name]="sub.key + opt.name"
                                      formControlName="{{ sub.key + index }}"
                                      [checked]="medHistoryForm.get(sub.key).value === opt.name"
                                      [isValid]="formControlUtilitiesService.isControlValid(medHistoryForm, sub.key)"
                                      (prismUiRadioButtonOnChange)="logYesNoRadioChangeEvent(sub.key, opt.name)"
                                      >
                                    </prism-ui-radio-button>
                                  </div>
                                }
                              </div>
                              @if (medHistoryForm.get(sub.key).value === 'yes') {
                                <app-additional-details [mhsControl]="sub" [parentForm]="medHistoryForm"></app-additional-details>
                                @if (sub.levelTwoQuestions && sub.levelTwoQuestions.length > 0) {
                                  <app-mhs-checkbox [parentKey]="sub.key" [id]="sub.key + '-checkbox-group'"
                                  [parentForm]="medHistoryForm" [levelTwoQuestions]="sub.levelTwoQuestions" [listType]="sub.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                                }
                              }
                            }
                            @if (sub.controlType === 'checkboxes') {
                              <app-mhs-checkbox [parentKey]="sub.key" [parentForm]="medHistoryForm" [controlType]="sub.controlType"
                              [levelTwoQuestions]="sub.levelTwoQuestions" [listType]="sub.listType" [selectionMaximum]="con.selectionMaximum?con.selectionMaximum:''"></app-mhs-checkbox>
                            }
                          }
                        </ol>
                      }
                    }
                  </ol>
                </div>
              }
            </div>
          </div>
        </prism-ui-container>
        <div class="continueCancelButtonPadding">
          @if (isEditFromReview) {
            <prism-ui-button-group
              key-id="medical-history-edit-button-group"
              buttons-count="2"
              spacing="default"
              class="editActionButtons"
            >
              <prism-ui-button
                slot="1"
                button-width="full"
                key-id="back-button"
                size="md"
                variant="secondary"
                type="button"
                is-icon-right-aligned="false"
                (click)="goBack()"
              >Back</prism-ui-button>
              <prism-ui-button
                slot="2"
                button-width="full"
                key-id="save-button"
                size="md"
                variant="primary"
                type="button"
                is-icon-right-aligned="false"
                (click)="saveAndGoToReview()"
              >Save</prism-ui-button>
            </prism-ui-button-group>
          } @else {
            <app-continue-cancel 
              (cancelEmitter)="onCancel()" 
              (backEmitter)="onBack()"
              [showBackButton]="showBackButton"
            ></app-continue-cancel>
          }
        </div>
      </form>
      @if (formSubmitted && !isEditFromReview) {
        <div class="page-loader">
          <prism-ui-loader
            has-logo="false"
            is-reverse="false"
            key-id="page-loader"
            size="md"
            >
          </prism-ui-loader>
          <prism-ui-copy
            font-size="md"
            font-style="normal"
            font-weight="regular"
            key-id="spinner-loading-text"
            line-height="medium"
            text-decoration="none"
            variant="default"
            >
            <span>Please wait while we process your request</span>
          </prism-ui-copy>
        </div>
      }
    </div>
